<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>推广码</p>
      </div>
    </div>
    <el-form class="mwow-wrap form" size="mini">
      <el-row>
        <el-col :span="8">
          <el-form-item label="市场顾问:" prop="title">
            <el-select
              v-model="searchInfo.market_staff_id"
              placeholder="请输入市场顾问姓名或手机号"
              clearable
              filterable
              :filter-method="handleSearchMarketStaff"
              @change="handleSearch"
            >
              <el-option
                v-for="item in market_staff_list"
                :key="item.staff_id"
                :label="item.name"
                :value="item.staff_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table
      size="mini"
      :data="tableData"
      stripe
      ref="tableRef"
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
    >
      <el-table-column label="序号" type="index" width="70"> </el-table-column>
      <el-table-column label="市场顾问名称" prop="name" width="150">
        <template slot-scope="scope">
          {{ scope.row.market_staff ? scope.row.market_staff.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="市场顾问手机号" prop="mobile" width="150">
        <template slot-scope="scope">
          {{ scope.row.market_staff ? scope.row.market_staff.mobile : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="推广码" prop="mini_qrcode" width="150">
        <template slot-scope="scope">
          <el-image
            id="image"
            v-if="scope.row.mini_qrcode"
            style="width: 100px; height: 100px"
            :src="scope.row.mini_qrcode"
            :preview-src-list="[scope.row.mini_qrcode]"
          >
          </el-image>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="推广路径" prop="mini_path" width="150">
        <template slot-scope="scope">
          {{ scope.row.mini_path ? scope.row.mini_path : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="推广链接" prop="url">
        <template slot-scope="scope">
          {{ scope.row.url ? scope.row.url : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="opreation" width="350">
        <template slot-scope="scope">
          <div class="btns">
            <el-button
              class="mwow-button primary"
              @click="handleDownloadCode(scope)"
              >下载推广码</el-button
            >
            <el-button class="mwow-button primary" @click="handleCopyUrl(scope)"
              >复制路径</el-button
            >
            <el-button
              class="mwow-button primary"
              @click="handleCopyLink(scope)"
              >复制链接</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <el-image v-show="false" ref="imageRef" :preview-src-list="srcList">
    </el-image>
  </div>
</template>
<script>
import {
  getPromotionQrcodeListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";

export default {
  name: "activityManagement",
  data() {
    return {
      searchInfo: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      canvasDom: "",
      srcList: [],
      market_staff_list: [],
      timer: "",
    };
  },
  created() {
    if (this.$route.query.activity_id) {
      this.getList();
    }
    this.getMarketStaffListApiFn();
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      params.page = 1;
      params.page_size = this.pageSize;
      if (this.searchInfo.market_staff_id) {
        params.market_staff_id = this.searchInfo.market_staff_id;
      }
      if (this.$route.query.activity_id) {
        params.activity_id = this.$route.query.activity_id;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getPromotionQrcodeListApi(option).then((res) => {
        if (res.error_code === 0) {
          if (res.data.list.length > 1) {
            res.data.list[0].market_staff = {
              name: "官方",
              mobile: "-",
            };
          }
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList();
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.debounce(this.getMarketStaffListApiFn, v, 500);
    },
    debounce(fn, data, delay) {
      // 设置一个触发开关
      let _t = this;
      clearTimeout(_t.timer);
      _t.timer = setTimeout(() => {
        fn(data);
      }, delay);
    },

    // 下载推广码
    handleDownloadCode(scope) {
      let image = new Image();
      image.src = scope.row.mini_qrcode;
      image.setAttribute("crossOrigin", "anonymous");
      let canvas = document.createElement("canvas");
      canvas.width = 430;
      canvas.height = 430;
      let context = canvas.getContext("2d");
      image.onload = () => {
        context.drawImage(image, 0, 0, 430, 430);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        a.href = url;
        a.download = "推广码";
        a.click();
        a.remove();
        image.onload = null;
      };
    },
    // 复制路径
    async handleCopyUrl(scope) {
      await navigator.clipboard.writeText(scope.row.mini_path);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    // 复制链接
    async handleCopyLink(scope) {
      await navigator.clipboard.writeText(scope.row.url);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleBack() {
      this.$router.push({
        name: "activityManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
}

/deep/.form {
  padding-top: 20px;
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 100px !important;
    }
    .el-form-item__content {
      width: 74%;
      div:nth-child(1) {
        width: 100%;
      }
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}

.qr-code {
  width: 110px;
  height: 110px;
  border-radius: 4px;
  overflow: hidden;
  display: block;
  padding: 5px 0 0 5px;
  &:hover {
    cursor: pointer;
  }
}
</style>
